import { Link } from "react-router-dom";

type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-2 text-sm text-foreground-500"
    >
      <Link to="/" className="flex items-center gap-1 hover:text-primary-600 transition-colors">
        <i className="ri-home-4-line text-base" />
        <span>首页</span>
      </Link>
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={`${item.label}-${idx}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-300" />
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "font-medium text-foreground-900" : ""}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}